import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "fwdRef", "tagName"];
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { buildVersionedClass } from '@op/opds.opux-utilities';
const rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];

/**
 * Rows are used to structure the layout vertically. Row properties enable
 * controlling how its contents are distributed and aligned inside of it.
 *
 * Additional props (including `ref`) will be forwarded to the HTML element.
 */
export const Row = _ref => {
  let {
      className,
      fwdRef,
      tagName: Tag = 'div'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const cl = [className, buildVersionedClass('ds-row')];
  for (const key of rowKeys) {
    const value = props[key];
    if (value) {
      const size = value === true ? 'xs' : value;
      cl.push(buildVersionedClass("ds-row--" + key + "-" + size));
      delete props[key];
    }
  }
  if (props.reverse) {
    cl.push(buildVersionedClass('ds-row--reverse'));
    delete props.reverse;
  }
  return /*#__PURE__*/ /* @ts-expect-error -- Typing fwdRef as HTMLElement will not work with any tag therefore we just ignore the error */React.createElement(Tag, _extends({}, props, {
    className: classNames(cl),
    ref: fwdRef
  }));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Row, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Row';
export default Fwd;